module.exports = "/assets/kinley-page/photo-section.jpg?ijx8A+F";